// extracted by mini-css-extract-plugin
export var content = "label-module--content--nTj+Q";
export var wrapper = "label-module--wrapper--slUBV";